import config from "@/data/config";

const env = {
  getters: {
    isDebugMode() {
      return process.env.VUE_APP_DEBUG === "true";
    },
    useAuth() {
      return process.env.VUE_APP_DO_AUTH === "true";
    },
    useDatastore() {
      return process.env.VUE_APP_USE_DATASTORE === "true";
    },
    useLandingPage() {
      return config.settings.useLandingPage === true;
    },
    useNavbar() {
      return config.settings.useNavbar === true;
    },
    publicKey(state, getters) {
      let key = process.env.VUE_APP_PUBLIC_KEY;

      key =
        getters.isDebugMode && process.env.VUE_APP_USE_DATASTORE === "true"
          ? `9${key}`
          : key;

      return key;
    }
  }
};

export default env;
